import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { SuccessToastComponent } from '../components/success-toast/success-toast.component'
import { ErrorToastComponent, WarningToastComponent } from '../components/error-toast/error-toast.component'

@Injectable()
export class ToastService {

    constructor(public snackBar: MatSnackBar) { }
    success() {
        this.snackBar.openFromComponent(SuccessToastComponent, {
            duration: 5000,
        });
    }

    successWithMessage(msg) {
        this.snackBar.openFromComponent(SuccessToastComponent, {
            duration: 5000,
            data: {message: msg}
        });
    }

    error(errMsg) {
        this.snackBar.openFromComponent(ErrorToastComponent, {
            data: errMsg,
            duration: 5000,
        });
    }

    warning(errMsg) {
        this.snackBar.openFromComponent(WarningToastComponent, {
            data: errMsg,
            duration: 5000,
        });
    }
}
